/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDashboardRequestBody,
  CreateDashboardRequestBody$Outbound,
  CreateDashboardRequestBody$outboundSchema,
} from "../components/createdashboardrequestbody.js";

export type CreateDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateDashboardRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createDashboardRequestBody: CreateDashboardRequestBody;
};

/** @internal */
export type CreateDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateDashboardSecurity$outboundSchema: z.ZodMiniType<
  CreateDashboardSecurity$Outbound,
  CreateDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createDashboardSecurityToJSON(
  createDashboardSecurity: CreateDashboardSecurity,
): string {
  return JSON.stringify(
    CreateDashboardSecurity$outboundSchema.parse(createDashboardSecurity),
  );
}

/** @internal */
export type CreateDashboardRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateDashboardRequestBody: CreateDashboardRequestBody$Outbound;
};

/** @internal */
export const CreateDashboardRequest$outboundSchema: z.ZodMiniType<
  CreateDashboardRequest$Outbound,
  CreateDashboardRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createDashboardRequestBody: CreateDashboardRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createDashboardRequestBody: "CreateDashboardRequestBody",
    });
  }),
);

export function createDashboardRequestToJSON(
  createDashboardRequest: CreateDashboardRequest,
): string {
  return JSON.stringify(
    CreateDashboardRequest$outboundSchema.parse(createDashboardRequest),
  );
}
